export default {
  name: 'eventSuperSleuth',
  options: {
    menuIndex: 2,
    isHidden: true,
  },
};
